import { useEffect, useMemo, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useSelection } from "../SelectionContext";
import { resolveAuditScopeContext } from "./auditScope";

export default function useAuditScope() {
  const { user } = useAuth();
  const { selectedCompany } = useSelection();
  const [auditScope, setAuditScope] = useState("company");

  const context = useMemo(
    () =>
      resolveAuditScopeContext({
        user,
        requestedScope: auditScope,
        selectedCompany,
      }),
    [auditScope, selectedCompany, user]
  );

  useEffect(() => {
    if (!context.isSuperAdmin && auditScope !== "company") {
      setAuditScope("company");
    }
  }, [auditScope, context.isSuperAdmin]);

  return {
    ...context,
    auditScope,
    setAuditScope,
  };
}
